<template>
    <div class="o-sms-modal-fail sms-modal-fail">
        <div class="sms-modal-fail__layer sms-modal-fail__layer--phone">
            <svg-icon
                original
                name="backgrounds/phone-frame-gray"
                class="sms-modal-fail__phone-icon"
            />
        </div>
        <div class="sms-modal-fail__layer sms-modal-fail__layer--main">
            <svg-icon
                original
                name="icons/fail"
                class="sms-modal-fail__fail-icon"
            />
            <span 
                class="sms-modal-fail__title"
                v-html="$t('o-sms-modal-fail_title')"
            />
            <span
                class="sms-modal-fail__text"
                v-html="$t('o-sms-modal-fail_text')"
            />
        </div>
    </div>
</template>

<script>

export default {
    name: 'OSmsModalFail'
}
</script>

<style lang="scss">
@import "o-sms-modal-fail";
</style>
